import styled from 'styled-components'

export const NavigationBarBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 1% 15%;
  box-sizing: border-box;
  background-image: linear-gradient(to right, #728ffb, #e896b1 98%);
  z-index: 10;

  &:not(.browser-view){
  @media only screen and (max-width: 600px) {
    max-width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 4% 10% 10% 10%;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }
}

  &.tablet-view{
  @media (min-width: 1024px) and (max-width: 1280px) {
    max-width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 2%;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    justify-content: center;
    box-shadow: 0px 0px 22px -13px rgba(0, 0, 0, 0.23),
      0px 0px 37.3px -13px rgba(0, 0, 0, 0.165),
      0px 0px 47px -13px rgba(0, 0, 0, 0.137),
      0px 0px 52.7px -13px rgba(0, 0, 0, 0.115),
      0px 0px 59.1px -13px rgba(0, 0, 0, 0.093),
      0px 0px 93px -13px rgba(0, 0, 0, 0.065);
  }
  border: 1px solid rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 2%;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    justify-content: center;
    box-shadow: 0px 0px 22px -13px rgba(0, 0, 0, 0.23),
      0px 0px 37.3px -13px rgba(0, 0, 0, 0.165),
      0px 0px 47px -13px rgba(0, 0, 0, 0.137),
      0px 0px 52.7px -13px rgba(0, 0, 0, 0.115),
      0px 0px 59.1px -13px rgba(0, 0, 0, 0.093),
      0px 0px 93px -13px rgba(0, 0, 0, 0.065);
  }
}

  &.player-view {
    &:not(.browser-view){
    @media (max-width: 1000px) and (orientation: landscape) {
      display: none;
    }
  }
  }
`

export const NavigationItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);

  &.blurred {
    filter: blur(1px) grayscale(0.5);
    cursor: pointer;
    opacity: 0.3;
    transition: none;

    &:hover {
      opacity: 0.3;
    }
  }

  &.active {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }

  &.middle-icon {
    margin: 0 20%;

    @media only screen and (max-width: 600px) {
      margin: 0;
    }
  }
  @media (min-width: 1024px) and (max-width: 1280px) {
    margin: 0 10% !important;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    margin: 0 10% !important;
  }
`

export const NavigationItemsBox = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;

  @media only screen and (max-width: 600px) {
    width: 100%;
    justify-content: space-between;
  }
`
